export const COMPARISON_BAR_CHART_COLORS = {
  SUCCESS: {
    PREV: '#E6F8C6',
    CURRENT: '#B3E5D2',
  },
  DECLINED: {
    PREV: '#FFE5CB',
    CURRENT: '#FFC29D',
  },
};
